const servicePhone = '客服热线: 020-80922370/80922307/80922371 (国家法定工作日8:30-12:00，14:00-17:30)'
const joinPhone = '加盟热线: 020-80922371/80922713'
const serviceQQ = '客户服务QQ: '
const QQ = '800180619'
const qqTip = '点击打开客服聊天窗口'
const qqHref = 'http://q.url.cn/abmocP?_type=wpa&qidian=true'

export default {
  servicePhone,
  joinPhone,
  serviceQQ,
  QQ,
  qqTip,
  qqHref
}



// WEBPACK FOOTER //
// ./src/js/config.js